import { useCallback, useSyncExternalStore } from 'react';

/**
 * Vrai tant que la media query est satisfaite, suivi en direct (rotation, redimensionnement). Sans matchMedia (jsdom,
 * rendu serveur), faux : l'affichage desktop par défaut.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => {};
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () => typeof window !== 'undefined' && !!window.matchMedia?.(query).matches,
    () => false,
  );
}

/** Sous le point de rupture md de Tailwind (768 px) : cartes et saisie plein écran au lieu des tableaux */
export const MOBILE_QUERY = '(max-width: 767.98px)';

export const useIsMobile = () => useMediaQuery(MOBILE_QUERY);
